import { render, staticRenderFns } from "./BasicTextInput.vue?vue&type=template&id=dce56f38&scoped=true"
import script from "./BasicTextInput.vue?vue&type=script&lang=js"
export * from "./BasicTextInput.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dce56f38",
  null
  
)

export default component.exports